module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', [_c('div', {
    staticClass: "row justify-content-center justify-content-lg-start mt-5"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.overallData.organization.name))])]), _vm._v(" "), _c('div', {
    ref: "reviewDropDrown",
    staticClass: "row justify-content-center justify-content-lg-start mt-3",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        (_vm.showUserLocationLoader) ? _vm.reviewDropDrown = true: _vm.reviewDropDrown = !_vm.reviewDropDrown
      }
    }
  }, [_c('div', {
    staticClass: "reviewStarHolder"
  }, [_c('div', {
    class: _vm.ol = (_vm.overallData.organization.overall_pct.toFixed(2) * 5).toFixed(1)
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborder mr-1 ml-2 st1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    class: {
      reviewhalficonfill: (_vm.ol >= 0.5) ? true : false, reviewiconfill: (_vm.ol >= 1) ? true : false
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborder mr-1 st2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    class: {
      reviewhalficonfill: (_vm.ol >= 1.5) ? true : false, reviewiconfill: (_vm.ol >= 2) ? true : false
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborder mr-1 st3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    class: {
      reviewhalficonfill: (_vm.ol >= 2.5) ? true : false, reviewiconfill: (_vm.ol >= 3) ? true : false
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborder mr-1 st4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    class: {
      reviewhalficonfill: (_vm.ol >= 3.5) ? true : false, reviewiconfill: (_vm.ol >= 4) ? true : false
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborder mr-1 st5",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    class: {
      reviewhalficonfill: (_vm.ol >= 4.5) ? true : false, reviewiconfill: (_vm.ol >= 5) ? true : false
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-column text-center dropdownreviews",
    class: {
      displayNot: _vm.reviewDropDrown
    }
  }, [_c('div', {
    staticClass: "p-2 small my-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s((_vm.overallData.organization.overall_pct.toFixed(2) * 5).toFixed(1)))]), _vm._v(" out of "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("5.0")]), _vm._v(" Stars")]), _vm._v(" "), _c('div', {
    staticClass: "reviewhover pb-2",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.reviewSelected('5 Stars');
        _vm.reviewDropDrown = !_vm.reviewDropDrown
      }
    }
  }, [_c('span', {
    staticClass: "small eachstartitlepadding color1"
  }, [_vm._v("5 Stars")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "reviewhover pb-2",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.reviewSelected('4 Stars');
        _vm.reviewDropDrown = !_vm.reviewDropDrown
      }
    }
  }, [_c('span', {
    staticClass: "small eachstartitlepadding color1"
  }, [_vm._v("4 Stars")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "reviewhover pb-2",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.reviewSelected('3 Stars');
        _vm.reviewDropDrown = !_vm.reviewDropDrown
      }
    }
  }, [_c('span', {
    staticClass: "small eachstartitlepadding color1"
  }, [_vm._v("3 Stars")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "reviewhover pb-2",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.reviewSelected('2 Stars');
        _vm.reviewDropDrown = !_vm.reviewDropDrown
      }
    }
  }, [_c('span', {
    staticClass: "small eachstartitlepadding color1"
  }, [_vm._v("2 Stars")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "reviewhover pb-2 mb-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.reviewSelected('1 Star');
        _vm.reviewDropDrown = !_vm.reviewDropDrown
      }
    }
  }, [_c('span', {
    staticClass: "small eachstartitlepadding color1"
  }, [_vm._v("1 Stars")]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('img', {
    staticClass: "droparrow",
    attrs: {
      "src": "builds/l_down_arrow.svg",
      "alt": "drop arrow"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reviewstext"
  }, [_c('p', {
    staticClass: "p-0 m-0 ml-2 color1"
  }, [_c('small', [_vm._v(_vm._s(_vm.overallData.organization.total_surveys.toLocaleString()) + " Reviews")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center justify-content-lg-start mt-4",
    style: ({
      visibility: (_vm.showUserLocationLoader) ? 'hidden' : 'visible'
    })
  }, [_c('div', {
    ref: "openStoreDropDown",
    staticClass: "blockbtn p-3",
    staticStyle: {
      "position": "relative"
    },
    on: {
      "click": _vm.selectastore
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "position": "relative",
      "top": "2px",
      "left": "220px",
      "pointer-events": "none",
      "width": "16px",
      "height": "14px"
    },
    attrs: {
      "src": "builds/l_down_arrow.svg",
      "alt": "drop arrow"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-1 m-0 pr-5"
  }, [_vm._v(_vm._s(_vm.storeSelected.name) + ", " + _vm._s(_vm.storeSelected.state))]), _vm._v(" "), _c('div', {
    staticClass: "dropdownfilterstores py-2",
    class: {
      displayNot: _vm.openStoreDropDown
    }
  }, _vm._l((_vm.overallData.stores), function(val, key, index) {
    return _c('a', {
      staticClass: "d-block py-3 px-2 color2",
      attrs: {
        "href": val.name,
        "lid": val.loupeid
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.storeselected(val)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(val.name) + ", " + _vm._s(val.state) + "\n                        ")])
  }))])]), _vm._v(" "), (_vm.showUserLocationLoader) ? _c('div', {
    staticClass: "text-center text-lg-left"
  }, [_c('pulse-loader', {
    attrs: {
      "color": {
        color: '#9a9c9f'
      }.color,
      "size": {
        size: '10px'
      }.size
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "h6 color2"
  }, [_vm._v("Please Wait..")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center justify-content-lg-start mt-4",
    style: ({
      visibility: (_vm.showUserLocationLoader) ? 'hidden' : 'visible'
    })
  }, [_c('div', {
    ref: "gmapstore",
    class: {
      displayNot: !_vm.gApiLoaded
    },
    staticStyle: {
      "width": "270px",
      "height": "100px",
      "border-radius": "17px"
    },
    attrs: {
      "id": "gmapstore"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "addresstext mt-4",
    style: ({
      visibility: (_vm.showUserLocationLoader) ? 'hidden' : 'visible'
    })
  }, [_c('p', {
    staticClass: "color1 text-center text-lg-left"
  }, [_vm._v(_vm._s(_vm.storeSelected.address1) + " " + _vm._s(_vm.storeSelected.address2))]), _vm._v(" "), _c('p', {
    staticClass: "color1 text-center text-lg-left"
  }, [_vm._v(_vm._s(_vm.storeSelected.city) + ", " + _vm._s(_vm.storeSelected.state) + " " + _vm._s(_vm.storeSelected.zip))]), _vm._v(" "), _c('p', {
    staticClass: "color1 text-center text-lg-left"
  }, [_vm._v(_vm._s(_vm.formatPhoneNumber(_vm.storeSelected.phone)))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.storeSelected.url
    }
  }, [_c('p', {
    staticClass: "color3 text-center text-lg-left"
  }, [_vm._v(_vm._s(_vm.storeSelected.url))])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center text-lg-left  mt-5",
    style: ({
      visibility: (_vm.showUserLocationLoader) ? 'hidden' : 'visible'
    })
  }, [_vm._m(5)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "d-inline-block "
  }, [_c('div', {
    staticClass: "reviewiconborderdark eachstarcolor1outline mr-1 ml-sm-2"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor1fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor1outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor1fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor1outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor1fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor1outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor1fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor1outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor1fill"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "reviewiconborderdark eachstarcolor2outline mr-1 ml-sm-2"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor2fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor2outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor2fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor2outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor2fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor2outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor2fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor2outline mr-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "reviewiconborderdark eachstarcolor3outline mr-1 ml-sm-2"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor3fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor3outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor3fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor3outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor3fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor3outline mr-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor3outline mr-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "reviewiconborderdark eachstarcolor4outline mr-1 ml-sm-2"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor4fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor4outline mr-1"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor4fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor4outline mr-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor4outline mr-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor4outline mr-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "reviewiconborderdark eachstarcolor5outline mr-1 ml-sm-2"
  }, [_c('div', {
    staticClass: "reviewiconfilldark eachstarcolor5fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor5outline mr-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor5outline mr-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor5outline mr-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewiconborderdark eachstarcolor5outline mr-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.apexenergygroup.com"
    }
  }, [_c('button', {
    staticClass: "blockbtn darkbtn "
  }, [_c('p', {
    staticClass: "h4 m-0"
  }, [_vm._v("Request More Info")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4575f1e7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./process/StoreSelection.vue
// module id = 161
// module chunks = 0